import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import type { JSX } from 'react';
import styled from 'styled-components';
import { colors } from '../../../theme/colors';
import { Flexbox } from '../../flexbox';
import { IconArrowDropDown } from '../../icons';
import { Text } from '../../text';
import type { DetailCardProps } from '../types';
import { INNER_PADDING } from '../utils';
export function IconTitleSubtitleBlock(props) {
  const $ = _c(34);
  const {
    icon,
    title,
    subtitle,
    subtitleComponent,
    expanded,
    showChevron: t0,
    setExpanded,
    titleColor,
    isHighlighted,
    showSubtitleComponentWhenExpanded,
    testId,
    highlightColor
  } = props;
  const showChevron = t0 === undefined ? true : t0;
  let t1;
  if ($[0] !== icon) {
    t1 = icon && <>{icon}</>;
    $[0] = icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== expanded || $[3] !== setExpanded || $[4] !== showChevron) {
    t2 = showChevron ? () => setExpanded(!expanded) : undefined;
    $[2] = expanded;
    $[3] = setExpanded;
    $[4] = showChevron;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = isHighlighted ? highlightColor || colors.brand[400] : titleColor;
  const t4 = `${testId}-title`;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      color: "currentColor"
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== title) {
    t6 = <strong style={t5}>{title}</strong>;
    $[7] = title;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== expanded || $[10] !== showChevron || $[11] !== testId || $[12] !== titleColor) {
    t7 = showChevron && <StyledArrowDiv className={expanded ? "expanded" : undefined}><IconArrowDropDown color={titleColor} size={20} testId={`${testId}-expand-btn`} /></StyledArrowDiv>;
    $[9] = expanded;
    $[10] = showChevron;
    $[11] = testId;
    $[12] = titleColor;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t3 || $[15] !== t4 || $[16] !== t6 || $[17] !== t7) {
    t8 = <Text color={t3} testId={t4} breakword={true}>{t6}{t7}</Text>;
    $[14] = t3;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== showChevron || $[20] !== t2 || $[21] !== t8) {
    t9 = <StyledTitleChevron $isClickable={showChevron} onClick={t2}>{t8}</StyledTitleChevron>;
    $[19] = showChevron;
    $[20] = t2;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== isHighlighted || $[24] !== subtitle || $[25] !== testId) {
    t10 = subtitle ? <Text color={isHighlighted ? colors.brand[400] : "light"} testId={`${testId}-subtitle`} breakword={true}>{subtitle}</Text> : null;
    $[23] = isHighlighted;
    $[24] = subtitle;
    $[25] = testId;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  const t11 = subtitleComponent && (!expanded || expanded && showSubtitleComponentWhenExpanded) ? subtitleComponent : null;
  let t12;
  if ($[27] !== t10 || $[28] !== t11 || $[29] !== t9) {
    t12 = <Flexbox flexDirection="column" justifyContent="space-between">{t9}{t10}{t11}</Flexbox>;
    $[27] = t10;
    $[28] = t11;
    $[29] = t9;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t1 || $[32] !== t12) {
    t13 = <Flexbox gap={INNER_PADDING} paddingLeft={4}>{t1}{t12}</Flexbox>;
    $[31] = t1;
    $[32] = t12;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  return t13;
}
const StyledArrowDiv = styled.div`
  transition: transform 0.3s ease;
  border-radius: 50%;
  background: none;
  display: inline-block;
  position: absolute;
  margin-left: ${INNER_PADDING}px;

  &.expanded {
    transition: transform 0.3s ease;
    transform: rotate(180deg);
  }
`;
const StyledTitleChevron = styled.div<{
  $isClickable: boolean;
}>(({
  $isClickable
}: {
  $isClickable: boolean;
}) => `
  cursor: ${$isClickable ? 'pointer' : 'default'};
  position: relative;
  &:hover {
    ${StyledArrowDiv} {
      background: ${colors.steel[100]};
    }
  }
  `);